import { Table, Text, Stack } from "@mantine/core";
import { PortalAccessGrant } from "../../../services/admin/portalAccess.service";
import { PortalGrantStateBadge } from "./PortalGrantStateBadge";
import { PortalSubjectTypeBadge } from "./PortalSubjectTypeBadge";
import { PortalGrantActionsMenu } from "./PortalGrantActionsMenu";
import { PortalNotificationPreferenceSummary } from "./PortalNotificationPreferenceSummary";

interface PortalGrantAdminRowProps {
  grant: PortalAccessGrant;
  onEdit: (grant: PortalAccessGrant) => void;
}

function formatDateTime(value: string | null): string {
  if (!value) return "—";
  return new Date(value).toLocaleString();
}

function buildDisplayName(grant: PortalAccessGrant): string {
  const first = grant.firstName ?? grant.portalIdentity.firstName ?? "";
  const last = grant.lastName ?? grant.portalIdentity.lastName ?? "";
  const combined = [first, last].filter(Boolean).join(" ").trim();
  return combined || grant.portalIdentity.email;
}

export function PortalGrantAdminRow({
  grant,
  onEdit,
}: PortalGrantAdminRowProps) {
  return (
    <Table.Tr>
      <Table.Td>
        <Stack gap={2}>
          <Text size="sm" fw={500}>
            {grant.portalIdentity.email}
          </Text>
          <Text size="xs" c="dimmed">
            {buildDisplayName(grant)}
          </Text>
          <Text size="xs" c="dimmed">
            Role: {grant.role ?? "—"}
          </Text>
        </Stack>
      </Table.Td>
      <Table.Td>
        <Stack gap={4} align="flex-start">
          <PortalSubjectTypeBadge subjectType={grant.subjectType} />
          <Text size="sm">{grant.subjectName}</Text>
        </Stack>
      </Table.Td>
      <Table.Td style={{ verticalAlign: "top", whiteSpace: "nowrap" }}>
        <PortalGrantStateBadge state={grant.state} />
      </Table.Td>
      <Table.Td>
        <PortalNotificationPreferenceSummary
          lastDigestSentAt={grant.lastDigestSentAt}
          preference={grant.notificationPreference}
        />
      </Table.Td>
      <Table.Td>
        <Text size="sm" c="dimmed">
          {formatDateTime(grant.portalIdentity.lastLoginAt)}
        </Text>
      </Table.Td>
      <Table.Td style={{ width: 60 }}>
        <PortalGrantActionsMenu grant={grant} onEdit={onEdit} />
      </Table.Td>
    </Table.Tr>
  );
}
